import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useComponentVisible } from "../../hooks";
import logoutImg from "../../../../assets/img/logout.png";

import store from "../../redux/store";
import * as Actions from "../../redux/actions";

const GetMenuItem = ({ categoryMarkas, setOpenBurger, type, catalogData }) => {
  const markas =
    categoryMarkas &&
    Object.keys(categoryMarkas).map((key) => categoryMarkas[key]);
  return (
    <ul className="menuItem-container">
      {catalogData &&
        catalogData.map((element, i) => {

          // ${
          //   markas &&
          //   Object.keys(markas[i])[0]
          //     .replace(" ", "-")
          //     .toLowerCase()
          // }
          return (
            <li key={i} className="menuItem">
              <Link
                onClick={() => setOpenBurger()}
                to={
                  type !== "categorias"
                    ? `${type}/${element.code}`
                    : markas && Object.keys(markas[i]).length !== 1
                    ? `${type}/${element.code}`
                    : `${type}/${element.code}`
                }
              >
                {element.name.toUpperCase()}
                <div className="underLine" />
              </Link>
            </li>
          );
        })}
    </ul>
  );
};

const GetMenuBlocks = ({ categoryMarkas, setOpenBurger, catalogData }) => {
  const catalogs = useSelector((state) => state.catalogs.catalogs);
  const categories = useSelector((state) => state.categories.categories);
  const marca = useSelector((state) => state.marcas.marcas);

  const marcas = "marcas";
  const catalogo = "catalogos";
  const categoria = "categorias";

  return (
    <div className="menu-blocks">
      <div className="block">
        <div className="title">Por marcas</div>
        {marca &&
          <GetMenuItem
            setOpenBurger={setOpenBurger}
            type={marcas}
            catalogData={marca}
          />
        }
      </div>
      <div className="block">
        <div className="title">Por catálogo</div>
        {catalogs &&
          <GetMenuItem
            setOpenBurger={setOpenBurger}
            type={catalogo}
            catalogData={catalogs}
          />
        }
      </div>
      <div className="block">
        <div className="title">Por categoría</div>
        {categories &&
          <GetMenuItem
            categoryMarkas={categoryMarkas}
            setOpenBurger={setOpenBurger}
            type={categoria}
            catalogData={categories}
          />
        }
      </div>
    </div>
  );
};

const Menu = ({ openBurger, setOpenBurger }) => {
  const catalogData = useSelector((state) => state.catalog.catalogData);
  const categoryMarkas = useSelector((state) => state.catalog.categoryMarkas);


  const { ref } = useComponentVisible(setOpenBurger, openBurger);


  const logout = () => {

    store.dispatch(Actions.logout()).then(res => {

    if (res.type === Actions.USER_LOGEDOUT) {

        store.dispatch(Actions.confirmAuth(false))
    
    } else {
      
        store.dispatch(Actions.confirmAuth(true))
    }})

  }


  return (
    <div
      ref={ref}
      className={`menu-container ${openBurger ? "menuOpen" : "menuClose"}`}
    >
      {openBurger && (
        <>
          <div className="top-bar">
            <div className="logout-btn" onClick={()=> logout()}>
              <img src={logoutImg}></img>
              <span>Logout</span>
            </div>
            <div
              className="closeButton"
              onClick={() => setOpenBurger(!openBurger)}
            >
              <div className="closeButtonElements">
                <div className="line lineTop"></div>
                <div className="line lineBottom"></div>
              </div>
            </div>
          </div>

          <div className="menu-content">
            {
              <GetMenuBlocks
                categoryMarkas={categoryMarkas}
                setOpenBurger={setOpenBurger}
                catalogData={catalogData}
              />
            }
          </div>
        </>
      )}
    </div>
  );
};

export default Menu;
